<template>
  <section v-if="pageData" class="lead-validation">
    <div class="lead-validation-container">
      <h1 v-if="_.get(pageData, 'title', '')" class="lead-validation__title">
        {{ _.get(pageData, 'title', '') }}
      </h1>
      <form
        class="lead-validation-form"
        @submit.prevent="onAccept(_.get(pageData, 'accept.url', ''))"
      >
        <BaseInput
          v-for="(field) in formData"
          :key="field.Name"
          v-model="field.Content"
          maxlength="100"
          :disabled="!field.Editable"
          :label="field.Label"
          :name="field.Name"
          :errorMsg="formatError(errorMessages[field.Name])"
          class="lead-validation-form-input"
        />
        <BaseCheckbox
          v-model="agree.Content"
          class="consultation-step3__form-input"
        >
                {{ agree.Label }}
          <span @click.prevent="setModal">
                <router-link
                  to="/policy"
                  class="stock__form-policy-link"
                >
                  {{ agree.link }}
                </router-link>
              </span>
        </BaseCheckbox>
        <BaseCheckbox
          v-model="marketing.Content"
          class="consultation-step3__form-input"
        >
                {{ marketing.Label }}
            <span @click.prevent="setModal">
                <router-link
                  to="/marketing"
                  class="stock__form-policy-link"
                >
                  {{ marketing.link }}
                </router-link>
              </span>
        </BaseCheckbox>
        <div class="lead-validation-form__buttons">
          <div class="lead-validation-form__buttons-inner">
            <div class="lead-validation-form__buttons-col">
              <BaseButton
                buttonNativeType="submit"
                type="main"
                class="lead-validation-form__btn lead-validation-form__btn_accept"
                :disabled="loading || !agree.Content"
              >
                {{ _.get(pageData, 'accept.label', '') }}
              </BaseButton>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'LeadValidation',
    data () {
      return {
        loading: false,
        pageData: null,
        formData: {},
        agree: {},
        marketing: {},
        errorMessages: {}
      }
    },

    async beforeCreate () {
      try {
        this.$store.commit('toggleVisibilityPreloader', true)
        this.pageData = await this.$store.dispatch('fetchFleetPageData')
        this.formData = _.cloneDeep(this.pageData.fields)
        this.agree = _.cloneDeep(this.pageData.agree)
        this.marketing = _.cloneDeep(this.pageData.marketing)
      } catch (error) {
        this.onError(error)
      } finally {
        this.$store.commit('toggleVisibilityPreloader', false)
      }
    },
    methods: {
      onError (error) {
        this.$router.push({
          name: 'not-found',
          params: {
            title: _.get(error, 'response.data.id', '') ? _.get(error, 'response.data.id', '') : `${_.get(error, 'response.data.status', '500')} ${_.get(error, 'response.data.name', '')}`,
            description: _.get(error, 'response.data.message', ''),
            buttonText: _.get(error, 'response.data.button', ''),
            goBack: true
          }
        })
      },
      formatError (msg) {
        if (!msg) return ''
        if (Array.isArray(msg)) return msg.join(', ')
        return msg
      },
      setModal (e) {
        e.preventDefault()
        const stockMarketing = {
          marketingConsentText: this.marketing.text,
          marketingCloseButtonText: this.marketing.closeButtonText,
          closeButtonText: this.marketing.closeButtonText
        }

        const stockPolicy = {
          policyText: this.agree.text,
          formSubmitUrl: '',
          closeButtonText: this.agree.closeButtonText
        }

        this.$store.commit('toggleVisibilityPreloader', true)
        localStorage.setItem('stockPolicy', JSON.stringify(stockPolicy))
        localStorage.setItem('marketing', JSON.stringify(stockMarketing))
        this.$store.commit('setMarketing', stockMarketing)
        this.$store.commit('setStockPolicy', stockPolicy)
      },
      async onAccept (url) {
        this.loading = true
        this.$store.commit('toggleVisibilityPreloader', true)

        try {
          const convertFormData = () => {
            const formData = new FormData()
            this.formData.forEach((item, index) => {
              if (item.Editable) {
                formData.append(`fields[${index}][Label]`, item.Label)
                formData.append(`fields[${index}][Name]`, item.Name)
                formData.append(`fields[${index}][Content]`, item.Content)
              }
            })

            formData.append(`agree`, this.agree.Content)
            formData.append(`marketing`, this.marketing.Content)
            return formData
          }

          const { data } = await window.axios({
            method: 'POST',
            url,
            data: convertFormData()
          })

          const success = data.success
          await this.$router.push({
            name: 'thank-you',
            params: {
              title: success && success.title ? success.title : '',
              description: success && success.description ? success.description : '',
              buttonLabel: success && success.buttonLabel ? success.buttonLabel : '',
              redirectUrl: 'https://www.toyota.ua/'
            }
          })
          this.$store.commit('toggleVisibilityPreloader', false)
        } catch (error) {
          if (error.response && error.response.status === 422) {
            this.$store.commit('toggleVisibilityPreloader', false)
            const serverErrors = error.response.data || {}

            this.errorMessages = {}
            await this.$nextTick()

            for (const [key, value] of Object.entries(serverErrors)) {
              const newKey = key === 'email' ? 'emailaddress1' : key
              this.$set(this.errorMessages, newKey, value)
            }

            return
          }
          this.$store.commit('toggleVisibilityPreloader', false)
          this.onError(error)
        } finally {
          this.loading = false
        }
      },

      async onDecline (url) {
        this.loading = true

        try {
          const { data } = await window.axios({
            method: 'POST',
            url
          })

          console.log(data)
          this.$router.push({ name: 'thank-you', params: { title: 'Дякуємо за відповідь' } })
        } catch (error) {
          console.log(`onAccept ${error}`)
          this.onError(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss">
.lead-validation {
  padding-top: 40px;
  padding-bottom: 100px;

  &-container {
    max-width: 768px;
    padding-right: 15px;
    padding-left: 15px;
    margin: 0 auto;
  }

  .input__error-msg {
    width: 100%;
  }

  &__title {
    //
  }

  &-form {
    &__buttons {
      margin-top: 30px;

      &-inner {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 -15px -20px;
      }

      &-col {
        padding: 0 15px;
        margin-bottom: 20px;

        @include mobile {
          flex: 1 1 100%;
          max-width: 100%;
        }
      }
    }

    .lead-validation-form__btn {
      &_accept,
      &_decline {
        width: 100%;
      }
    }
  }
}
</style>
